import forgotPwd from './forgotPwd'

export const forgotPwdService = forgotPwd
